import SecureMacPolicyLayout, { SecureMacPolicySection } from "@/components/SecureMacPolicyLayout";

export default function SecureMacProTerms() {
  return (
    <SecureMacPolicyLayout
      eyebrow="SecureShield Pro terms"
      title="One-time purchase. Clear licence limits."
      description="These terms cover SecureShield Pro direct purchases through LightningFlow hosted Checkout. They do not replace Australian Consumer Law rights that cannot be excluded."
      seoTitle="SecureShield Pro Terms — LightningFlow"
      canonicalPath="/secureshield/pro-terms"
    >
      <SecureMacPolicySection title="Who we are">
        <p>
          TripleThree Global Pty Ltd trading as LightningFlow, South Australia. Contact:{" "}
          <a className="underline" href="mailto:contact@lightningflow.ai?subject=SecureShield%20Pro%20terms">
            contact@lightningflow.ai
          </a>.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="One-time purchase scope">
        <p>
          SecureShield Pro is offered as a one-time purchase for the licensed software edition described
          at checkout. It is not a subscription. Features and supported platforms are
          as published on the product page at the time of purchase.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Device activation">
        <p>
          Your SecureShield Pro licence covers up to three devices associated with
          your LightningFlow account. You can deactivate a device to free a slot, subject to abuse
          controls.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Offline grace">
        <p>
          Activated licenses may continue to operate offline for up to 30 days, after which the product
          may require a successful refresh against LightningFlow service to continue licensed use.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Updates and support">
        <p>
          Security and compatibility updates may be required to remain supported. Support is provided
          through published SecureShield support channels. LightningFlow does not promise uninterrupted
          availability of every historical build.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Prohibited redistribution">
        <p>
          You may not redistribute, resell, sublicense, reverse engineer except where permitted by law,
          or circumvent entitlement, licensing or download controls.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Refunds and revocation">
        <p>
          Refund handling is described in the{" "}
          <a className="underline" href="/secureshield/refunds">SecureShield refund policy</a>. A full refund,
          chargeback or dispute may revoke download and license refresh. Nothing here excludes
          non-excludable Australian Consumer Law rights.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Warranty and liability">
        <p>
          To the extent permitted by law, LightningFlow provides SecureShield Pro on an as-available basis
          and limits liability for indirect or consequential loss. These limits do not exclude
          guarantees that cannot be excluded under the Australian Consumer Law.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Governing law">
        <p>These terms are governed by the laws of South Australia, Australia.</p>
      </SecureMacPolicySection>
    </SecureMacPolicyLayout>
  );
}
